
interface SummarySectionProps {
  content: string;
}

const SummarySection = ({ content }: SummarySectionProps) => {
  return (
    <div className="bg-muted p-3 rounded-lg my-3 border border-muted-foreground/20 text-sm italic">
      <div className="text-xs uppercase font-semibold mb-1 text-muted-foreground">Summary</div>
      {content}
    </div>
  );
};

export default SummarySection;
